module.exports = "<h1 class=\"page-title\">\n  <a [routerLink]=\"['/']\">Cars and Comments</a>\n</h1>\n\n<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/baylorrae/code/tutorials/graphcool/garage/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main